<span [ngClass]="{
'text-danger': status === 'created',
'text-primary-color': status === 'in_progress',
'text-warning': status === 'not_finished',
'text-success': status === 'ready',
'text-info': status === 'invoice',
'text-dark': status === 'completed'}">
{{ status }}</span>
